<template>
  <div 
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 sidenav" 
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      
      <li class="nav-item" v-if="hasAccess('Dashboard')" @click="handleNavClick">
        <sidenav-collapse navText="Dashboard" :to="{ name: 'Dashboard' }">
          <template #icon><shop color="#ffffff" /></template>
        </sidenav-collapse>
      </li>

      <!-- Medical Dashboard Navigation Item -->
      <li class="nav-item" v-if="hasAccess('Medical Dashboard')" @click="handleNavClick">
        <sidenav-collapse navText="Medical Dashboard" :to="{ name: 'Medical Dashboard' }">
          <template #icon><i class="fas fa-heartbeat text-danger text-sm"></i></template>
        </sidenav-collapse>
      </li>
      
      <!-- ADDED: User Management (Admin Only) -->
      <li class="nav-item" v-if="hasAccess('User Management')" @click="handleNavClick">
        <sidenav-collapse navText="User Management" :to="{ name: 'User Management' }">
          <template #icon><i class="ni ni-settings-gear-65 text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Content')" @click="handleNavClick">
        <sidenav-collapse navText="Content" :to="{ name: 'Content' }">
          <template #icon><i class="ni ni-tv-2 text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <!-- NEW: Live Webhook (Real-time formatting) -->
      <li class="nav-item" v-if="hasAccess('Live Webhook')" @click="handleNavClick">
        <sidenav-collapse navText="Live Webhook" :to="{ name: 'Live Webhook' }">
          <template #icon><i class="ni ni-world text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Live Videos')" @click="handleNavClick">
        <sidenav-collapse navText="Live Videos" :to="{ name: 'Live Videos' }">
          <template #icon><i class="fab fa-youtube text-danger text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Users')" @click="handleNavClick">
        <sidenav-collapse navText="Users" :to="{ name: 'Users' }">
          <template #icon><Users color="#ffffff" /></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Media')" @click="handleNavClick">
        <sidenav-collapse navText="Media" :to="{ name: 'Media' }">
          <template #icon><Media color="#ffffff" /></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Media History')" @click="handleNavClick">
        <sidenav-collapse navText="Media History" :to="{ name: 'Media History' }">
          <template #icon><MediaHistory color="#ffffff" /></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Roles')" @click="handleNavClick">
        <sidenav-collapse navText="Roles" :to="{ name: 'Roles' }">
          <template #icon><Role color="#ffffff" /></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Device Group')" @click="handleNavClick">
        <sidenav-collapse navText="Device Group" :to="{ name: 'Device Group' }">
          <template #icon><DeviceGroup color="#ffffff" /></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('User Group')" @click="handleNavClick">
        <sidenav-collapse navText="User Group" :to="{ name: 'User Group' }">
          <template #icon><UserGroup color="#ffffff" /></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Play List')" @click="handleNavClick">
        <sidenav-collapse navText="Play List" :to="{ name: 'Play List' }">
          <template #icon><PlayList color="#ffffff" /></template>
        </sidenav-collapse>
      </li>

      <!-- ADDED: Active Playback Screen Player Link -->
      <li class="nav-item" v-if="hasAccess('Active Playback')" @click="handleNavClick">
        <sidenav-collapse navText="Active Playback" :to="{ name: 'Active Playback Player' }">
          <template #icon><i class="ni ni-button-play text-info text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Branches')" @click="handleNavClick">
        <sidenav-collapse :navText="branchNavText" :to="{ name: 'Branches' }">
          <template #icon><i class="ni ni-building text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Devices')" @click="handleNavClick">
        <sidenav-collapse navText="Devices" :to="{ name: 'Devices' }">
          <template #icon><i class="ni ni-tablet-button text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('DeletedContent')" @click="handleNavClick">
        <sidenav-collapse navText="Deleted Content" :to="{ name: 'DeletedContent' }">
          <template #icon><i class="ni ni-basket text-danger text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Emergency Broadcast')" @click="handleNavClick">
        <sidenav-collapse navText="Emergency Broadcast" :to="{ name: 'Emergency Broadcast' }">
          <template #icon><i class="ni ni-notification-70 text-danger text-sm"></i></template>
        </sidenav-collapse>
      </li>
      <!-- 🚀 ADDED: Marquee Broadcast Ticker Menu Item -->
      <li class="nav-item" v-if="hasAccess('Marquee Broadcast')" @click="handleNavClick">
        <sidenav-collapse navText="Marquee Broadcast" :to="{ name: 'MarqueeBroadcast' }">
          <template #icon><i class="ni ni-chat-round text-warning text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Device Position')" @click="handleNavClick">
        <sidenav-collapse navText="Device Position" :to="{ name: 'Device Position' }">
          <template #icon><i class="ni ni-pin-3 text-success text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Tokens')" @click="handleNavClick">
        <sidenav-collapse navText="Tokens" :to="{ name: 'Tokens' }">
          <template #icon><i class="ni ni-badge text-info text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <!-- ADDED: Services & Prefix -->
      <li class="nav-item" v-if="hasAccess('Services & Prefix')" @click="handleNavClick">
        <sidenav-collapse navText="Services & Prefix" :to="{ name: 'Services & Prefix' }">
          <template #icon><i class="ni ni-bullet-list-67 text-warning text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="hasAccess('Counter')" @click="handleNavClick">
        <sidenav-collapse navText="Counter" :to="{ name: 'Counter' }">
          <template #icon>
            <i class="ni ni-shop text-primary text-sm"></i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="isSuperAdmin" @click="handleNavClick">
        <sidenav-collapse navText="Installation Type" :to="{ name: 'Installation Type' }">
          <template #icon><i class="ni ni-settings text-primary text-sm"></i></template>
        </sidenav-collapse>
      </li>

      <!-- Superadmin Tenants Management -->
      <li class="nav-item" v-if="isSuperAdmin" @click="handleNavClick">
        <sidenav-collapse navText="Tenants" :to="{ name: 'Tenants' }">
          <template #icon><i class="ni ni-building text-warning text-sm"></i></template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import Shop from "../../components/Icon/Shop.vue";
import Users from "../../components/Icon/Users.vue";
import Media from "../../components/Icon/Media.vue";
import MediaHistory from "../../components/Icon/MediaHistory.vue";
import Role from "../../components/Icon/Role.vue";
import DeviceGroup from "../../components/Icon/DeviceGroup.vue";
import UserGroup from "../../components/Icon/UserGroup.vue";
import PlayList from "../../components/Icon/PlayList.vue";
import { mapMutations } from "vuex"; // Added for sidebar control
import { hasPermission } from "../../utils/permissions";

export default {
  name: "SidenavList",
  components: { SidenavCollapse, Shop, Users, Media, MediaHistory, Role, DeviceGroup, UserGroup, PlayList },
  data() {
    return {
      permissionTick: 0
    };
  },
  computed: {
    isSuperAdmin() {
      const _tick = this.permissionTick;
      if (_tick < 0) console.log(_tick);
      const role = (localStorage.getItem('userRole') || localStorage.getItem('role') || '').toLowerCase().trim();
      return ['superadmin', 'super admin', '1'].includes(role);
    },
    isMedicalUser() {
      const _tick = this.permissionTick;
      if (_tick < 0) console.log(_tick);
      const role = (localStorage.getItem("userRole") || localStorage.getItem("role") || "").toLowerCase().trim();
      const instType = String(localStorage.getItem("installationType") || localStorage.getItem("installation_type") || "").toLowerCase();
      return role === "doctor" || role.includes("doctor") || instType.includes("medical") || instType === "1";
    },
    isMedicalType() {
      const _tick = this.permissionTick;
      if (_tick < 0) console.log(_tick);
      const userStr = localStorage.getItem('user') || localStorage.getItem('user_info') || '{}';
      let user = {};
      try { user = JSON.parse(userStr); } catch (e) { user = {}; }
      const instType = String(user.installation_type_name || localStorage.getItem('installationType') || localStorage.getItem('installation_type_name') || '').toLowerCase();
      const instTypeId = Number(user.installation_type_id || localStorage.getItem('installation_type_id') || localStorage.getItem('installationType'));
      return instTypeId === 2 || instType.includes('medical');
    },
    branchNavText() {
      return this.isMedicalType ? 'Departments' : 'Branches';
    }
  },
  mounted() {
    window.addEventListener('storage', this.onStorageUpdate);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.onStorageUpdate);
  },
  methods: {
    ...mapMutations(["navbarMinimize"]), // Added to trigger sidebar toggle
    onStorageUpdate() {
      this.permissionTick++;
    },
    handleNavClick() {
      // Automatically hide the sidebar after a module is selected on mobile screens
      if (window.innerWidth < 1200) {
        this.navbarMinimize();
      }
    },
    hasAccess(moduleName) {
      // Reference tick to make method reactive to localStorage changes
      const _tick = this.permissionTick;
      if (_tick < 0) console.log(_tick);

      return hasPermission(moduleName, 'read');
    }
  }
};
</script>

<style scoped>
.sidenav {
  border-right: none;
  border-radius: 0 16px 16px 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  
  /* HIDE SCROLLBAR LOGIC */
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
}

.sidenav::-webkit-scrollbar {
  display: none;
}

/* ── MOBILE RESPONSIVE FIXES ── */
@media (max-width: 1199.98px) {
  .sidenav.navbar-collapse {
    display: block !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 250px;
    height: 100vh;
    z-index: 1040;
    transition: all 0.3s ease-in-out;
    background-color: inherit;
    box-shadow: 0 8px 26px -4px rgba(20, 20, 20, 0.15);
    padding-top: 100px !important;
    transform: translateX(-100%);
    visibility: hidden;
  }

  :global(.g-sidenav-show) .sidenav.navbar-collapse {
    transform: translateX(0) !important;
    visibility: visible !important;
  }
  
  .sidenav.show {
    transform: translateX(0);
    visibility: visible !important;
  }
}

:deep(.brand-name) { color: white !important; }
:deep(.nav-section-label) { color: rgba(255, 255, 255, 0.6) !important; }

.nav-item {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
</style>